import axios from "axios";

// Central axios instance — always sends cookies, and can attach the last-known
// access token as a Bearer header (belt-and-braces for the preview URL where
// third-party cookies are sometimes blocked).
export const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    withCredentials: true,
});

const TOKEN_KEY = "promptforge_access_token";

export function setStoredToken(token) {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
}
export function getStoredToken() {
    return localStorage.getItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
    const tok = getStoredToken();
    if (tok) {
        config.headers = config.headers || {};
        if (!config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${tok}`;
        }
    }
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
